/**
 * Barcode / SKU parsing helpers (Step 2 extraction).
 *
 * `checkForSKU` was copy-pasted (byte-identical logic) into StandardOrder.vue
 * and OrdersList.vue. It is pure (string in, object out) and never touches Vuex
 * or `this`, so it lives here and is unit-tested in isolation.
 */

/**
 * Break a weight/price-embedded barcode into its SKU `value` and (optionally)
 * embedded `price`. Mirrors the legacy in-component implementation exactly:
 *
 *   - 12-digit codes prefixed "20"/"02": value = digits 3-7, price = digits 8-11 / 100
 *   - 13-digit codes prefixed "20"/"02": value = digits 3-7, price = digits 8-12 / 100
 *   - anything else: value = the raw barcode (no price)
 *
 * @param {string} barcode
 * @returns {{ value: string, price?: number }}
 */
export function checkForSKU(barcode) {
  const barCode = {};
  if (barcode.length === 12) {
    const barCodeType = barcode.slice(0, 2);
    if (barCodeType === "20" || barCodeType === "02") {
      barCode.value = barcode.slice(2, 7);
      barCode.price = (parseInt(barcode.slice(7, 11)) / 100);
      return barCode;
    } else {
      barCode.value = barcode;
      return barCode;
    }
  } else if (barcode.length === 13) {
    const barCodeType = barcode.slice(0, 2);
    if (barCodeType === "20" || barCodeType === "02") {
      barCode.value = barcode.slice(2, 7);
      barCode.price = (parseInt(barcode.slice(7, 12)) / 100);
      return barCode;
    } else {
      barCode.value = barcode;
      return barCode;
    }
  } else {
    barCode.value = barcode;
    return barCode;
  }
}
